import { connect } from "react-redux";
// Router
import { withRouter } from "react-router-dom";

import MessageDialog from "components/MessageDialog";

// Action
import { closeMessageDialog } from "redux/modules/messageDialog";
// Utils
import history from "utils/history";
import { isAdmin, isCustomerAdmin } from "utils/formatter";

const mapStateToProps = state => ({ messageDialog: state.messageDialog });

const mapDispatchToProps = (dispatch, ownProps) => ({
  handleClose: () => dispatch(closeMessageDialog()),
  historyPush: path => history.push(path, ownProps),
  backToHome: () => {
    dispatch(closeMessageDialog());

    if (isAdmin()) {
      history.push("/customer_list", ownProps);
    } else if (isCustomerAdmin()) {
      history.push("/survey_list", ownProps);
    }

    window.location.reload();
  }
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(MessageDialog)
);



// WEBPACK FOOTER //
// ./src/containers/MessageDialogContainer.js